import { type CSSProperties } from 'react';
import { Link } from 'react-router-dom';

type Props = {
  to: string;
  size: 'small' | 'large';
  inverted?: boolean;
  style?: CSSProperties;
};

const Logo = ({ to }: Props) => {
  return (

    <Link to={to}>
      <img src='/logo.png' className="logo" alt='logo' />
    </Link>
  );
};

export default Logo;
